import React from "react";
import { useApp } from "../../../state/Context";

export default function Counters() {
  const { stats, statsLoading } = useApp();

  const visits = stats?.visits ?? 0;
  const calculations = stats?.calculations ?? 0;

  return (
    <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm text-neutral-600 dark:text-neutral-400">
      <div>
        Calculations Run:{" "}
        <span className="font-semibold text-neutral-900 dark:text-neutral-50">
          {statsLoading ? "…" : calculations.toLocaleString()}
        </span>
      </div>
      <div>
        Page Visits:{" "}
        <span className="font-semibold text-neutral-900 dark:text-neutral-50">
          {statsLoading ? "…" : visits.toLocaleString()}
        </span>
      </div>
    </div>
  );
}
